import { queryBuilder } from '~/api';

export const deleteCalendarEventAttachment = async (
  attachmentId: number
): Promise<void> => {
  await queryBuilder('DELETE', `calendar/event/attachment/${attachmentId}`);
  return;
};
